import { useQuery } from '@tanstack/react-query';
import {
  getAllEndpointHistories,
  getTotalActiveEndpointHistories,
} from '@/api/endpoint-history/endpoint-history';
import { HistoryAdvancedFilter } from '@/entities/history';

export const useGetAllEndpointHistories = (
  filter: HistoryAdvancedFilter,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  return useQuery({
    queryKey: [
      'getAllEndpointHistories',
      filter,
      page,
      limit,
      sortBy,
      sortDirection,
    ],
    queryFn: () =>
      getAllEndpointHistories(filter, page, limit, sortBy, sortDirection),
  });
};

export const useGetTotalActiveEndpointHistories = () => {
  return useQuery({
    queryKey: ['getTotalActiveEndpointHistories'],
    queryFn: () => getTotalActiveEndpointHistories(),
  });
};
